export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const tokenStore = useTokenStore();

  const { openToast } = useUserMessages();
  const { t, locale } = useEkI18n();

  const appApiFetch = $fetch.create({
    baseURL: config.public.apiBase,
    async onRequest(context) {
      const accessToken = await tokenStore.getAccessToken();

      context.options.headers.append(
        'Authorization', `Bearer ${accessToken.token}`
      );
      context.options.headers.append(
        'Localization', locale.value
      );
    },
    onRequestError() {
      openToast(t('alert.requestFailed'), ToastType.ERROR);
    },
    onResponseError() {
      openToast(t('alert.requestFailed'), ToastType.ERROR);
    }
  });

  return {
    provide: {
      appApiFetch
    }
  };
});
